export const PENDING_TEST_PLAN_IMPORT_KEY = 'pending_test_plan_import';

export const stagePendingTestPlanImport = ({ clid, cases, planId = null }) => {
  if (!clid || !Array.isArray(cases) || cases.length === 0) return;
  const payload = {
    clid: String(clid),
    cases,
    planId: planId || null,
    stagedAt: new Date().toISOString(),
  };
  try {
    sessionStorage.setItem(PENDING_TEST_PLAN_IMPORT_KEY, JSON.stringify(payload));
  } catch (err) {
    console.error('Failed to stage pending test plan import:', err);
  }
};

export const consumePendingTestPlanImport = (clid) => {
  if (!clid) return null;
  try {
    const raw = sessionStorage.getItem(PENDING_TEST_PLAN_IMPORT_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(PENDING_TEST_PLAN_IMPORT_KEY);
    const payload = JSON.parse(raw);
    if (String(payload?.clid) !== String(clid)) {
      return null;
    }
    if (!Array.isArray(payload?.cases) || payload.cases.length === 0) {
      return null;
    }
    return payload;
  } catch (err) {
    console.error('Failed to consume pending test plan import:', err);
    sessionStorage.removeItem(PENDING_TEST_PLAN_IMPORT_KEY);
    return null;
  }
};
